module.exports = __webpack_public_path__ + "img/light-fm-Path 38 Copy@3x.04aaf79c.png";